// Teddy Bear icon — remembr kids edition brandmark. Same flat stylised
// aesthetic as ForgetMeNotIcon: simple geometric shapes, mono fill (defaults
// to the remembr lavender), front-on sitting teddy with both paws holding
// a tiny forget-me-not flower against its chest.
export function TeddyIcon({ size = 28, className = "", color = "#6B7DB8", flowerColor = "#A8B5E0", flowerCenter = "#F4D068" }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <g fill={color}>
                {/* Ears */}
                <circle cx="18" cy="14" r="6" />
                <circle cx="46" cy="14" r="6" />
                {/* Inner ear darker dots */}
                <circle cx="18" cy="14" r="2.6" fill={color} opacity="0.55" />
                <circle cx="46" cy="14" r="2.6" fill={color} opacity="0.55" />
                {/* Head */}
                <circle cx="32" cy="22" r="11.5" />
                {/* Muzzle */}
                <ellipse cx="32" cy="25.5" rx="5.5" ry="4.2" fill="#FFFFFF" opacity="0.85" />
                {/* Nose */}
                <ellipse cx="32" cy="23.5" rx="1.6" ry="1.2" fill={color} opacity="0.95" />
                {/* Eyes */}
                <circle cx="27.5" cy="20" r="1.3" fill={color} opacity="0.95" />
                <circle cx="36.5" cy="20" r="1.3" fill={color} opacity="0.95" />
                {/* Body — gentle rounded chest */}
                <ellipse cx="32" cy="44" rx="13" ry="11.5" />
                {/* Belly highlight */}
                <ellipse cx="32" cy="46" rx="7.5" ry="6.5" fill="#FFFFFF" opacity="0.35" />
                {/* Left paw — coming around to chest */}
                <ellipse cx="22" cy="40" rx="4.5" ry="3.5" transform="rotate(-25 22 40)" />
                {/* Right paw — coming around to chest */}
                <ellipse cx="42" cy="40" rx="4.5" ry="3.5" transform="rotate(25 42 40)" />
                {/* Feet at the bottom */}
                <ellipse cx="24" cy="55" rx="4" ry="2.6" />
                <ellipse cx="40" cy="55" rx="4" ry="2.6" />
                {/* Foot pads (small accents) */}
                <circle cx="24" cy="55" r="1.1" fill="#FFFFFF" opacity="0.7" />
                <circle cx="40" cy="55" r="1.1" fill="#FFFFFF" opacity="0.7" />
            </g>
            {/* Forget-me-not flower held against the chest — slightly inset between the paws */}
            <g transform="translate(32 41) scale(0.32) translate(-32 -32)">
                <ellipse cx="32" cy="14" rx="9" ry="11" fill={flowerColor} opacity="0.95" />
                <ellipse cx="50" cy="26" rx="11" ry="9" fill={flowerColor} opacity="0.95" />
                <ellipse cx="44" cy="46" rx="10" ry="9" fill={flowerColor} opacity="0.95" />
                <ellipse cx="20" cy="46" rx="10" ry="9" fill={flowerColor} opacity="0.95" />
                <ellipse cx="14" cy="26" rx="11" ry="9" fill={flowerColor} opacity="0.95" />
                <circle cx="32" cy="32" r="9" fill="#FFFFFF" />
                <circle cx="32" cy="32" r="4.5" fill={flowerCenter} />
            </g>
        </svg>
    );
}
